import type { BlogPost } from '../types'

const post: BlogPost = {
  title: 'Let It Go',
  slug: 'let-it-go',
  category: 'Let It Go',
  date: '2025-04-30',
  image: 'https://dpnelson.com/wp-content/uploads/2025/04/let_it_go.webp',
  excerpt: "Forgiveness is tricky. Grievances fester. Insensitivity, betrayal. The demand for justice is tricky too. It's too easy for the line between the desire for justice and the desire for revenge…",
  body: `Forgiveness is tricky. Grievances fester. Insensitivity, betrayal.

The demand for justice is tricky too. It's too easy for the line between the desire for justice and the desire for revenge to be clouded.

We think justice will satisfy. We think vengeance will satisfy. The satisfaction is fleeting if it is EVER present. The only way to move on is to move on. Let it go.

But how? Here are some ideas.

- If you're setting out to get even with everybody, start by getting even with people you OWE. Of course this is nuts. By the time you've paid back everything you owe, your perspective will be on a much higher plane. You will have let it go. But really, make a list of everybody you've ever hurt. See what you can do to repair those relationships. Then see how you feel about the person who hurt you.

- Pray for the person who hurt you. You might start to see them as human, not the monster you've made them out in your head.

- Here's a crazy idea. Let the one who is without sin cast the first stone. Judge not, lest ye be judged. Remember, you're as fallible as the person who hurt you. Meditate on our own fallibility for a minute.

Try some of these and see how you feel. I'll bet you'll forget the original offense. And if not forgotten, its power will be reduced to insignificance.`,
}

export default post
